import React, { useEffect, useRef, useState } from "react";
import './footer.scss';
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState("");
  return (
    <>
      <section className='footer_main'>
        <div className='inner_footer'>
          <div className="custom-container">
            <div className="foootexxx">
              <div className='innner_neww'>
                <img src='\assets\footerlogo.svg' />
                <div className='innner_left lastnew'>
                  <h3>Privacy Policy</h3>
                  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                    <circle cx="2" cy="2" r="2" fill="white" fill-opacity="0.8" />
                  </svg>
                  <h3>Terms and Conditions</h3>
                </div>

              </div>
              <div>
                <div className='righhtside'>
                  <HashLink to="/#about" className={activeSection === "whychooseus" ? "active" : ""}>About</HashLink>
                  <HashLink to="/#overview" className={activeSection === "whychooseus" ? "active" : ""}>Overview</HashLink>
                  <HashLink to="/#howitswork" className={activeSection === "whychooseus" ? "active" : ""}>How it works</HashLink>
                  <HashLink to="/#benefits" className={activeSection === "whychooseus" ? "active" : ""}>Benefits</HashLink>
                </div>
                <div className='foottter_phone'>
                  <div className='innner_left'>
                    <h3>Privacy Policy</h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                      <circle cx="2" cy="2" r="2" fill="white" fill-opacity="0.8" />
                    </svg>
                    <h3>Terms and Conditions</h3>
                  </div>
                </div>

                <h5>© 2025. All rights reserved</h5>
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  )
}

export default Footer
